<cm-template-scene-viewer-options class="cm-debug-menu" [selectedCameraId]="undefined" [threeViewer]="$threeViewer()"></cm-template-scene-viewer-options>
